import type { GetListTodos } from "@classes-service-types/index.ts";
import type { AxiosResponse } from "axios";
import type { GetTodosParams } from "@/components/modals/todos/types.ts";
import { learningServiceRequest, skip } from "./utils.js";

const todosService = {
  async getTodos({
    limit = 10,
    page = 1,
    q = "",
    status = [],
    title = "",
  }: GetTodosParams): Promise<AxiosResponse<GetListTodos>> {
    return learningServiceRequest({
      method: "get",
      url: "/programming/todos",
      params: { limit, skip: skip(page, limit), q, status, title },
      failureMessage: "Error loading todos data",
    });
  },
};

export default todosService;
